module.exports = __webpack_public_path__ + "img/text-classification.ecf19255.png";